import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MwcIconModule } from 'mwc/icon';
import { MwcNavBottomComponent } from './nav-bottom.component';

@NgModule({
  imports: [CommonModule, RouterModule, MwcIconModule],
  declarations: [MwcNavBottomComponent],
  exports: [MwcNavBottomComponent]
})
export class MwcNavBottomModule {}
